import styles from "./template-preview.module.css";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { useTemplateThumbnail } from "./use-template-thumbnail";
import { Size } from "PosterEditor/model/poster-types";

interface TemplatePreviewProps {
  template: ProjectTemplate;
  size?: Size;
}

export const TemplatePreview = ({
  template,
  size = { width: 140, height: 140 },
}: TemplatePreviewProps) => {
  const { image, size: resolvedSize } = useTemplateThumbnail({
    template: template,
    size: size,
  });

  return (
    <img
      className={styles.previewImage}
      style={{
        height: resolvedSize.height,
        width: resolvedSize.width,
        objectFit: "contain",
      }}
      src={image}
      alt={template.name}
    />
  );
};
